import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ScriptReviewHubPage } from "@/features/script-review/pages/ScriptReviewHubPage";

export const Route = createFileRoute("/_authenticated/pre-flight-scripts/")({
  component: ScriptReviewHubRoute,
});

function ScriptReviewHubRoute() {
  const navigate = useNavigate();
  return (
    <ScriptReviewHubPage
      onOpenReview={(reviewId) =>
        void navigate({
          to: "/pre-flight-scripts/review/$reviewId",
          params: { reviewId },
        })
      }
    />
  );
}
